'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_digitalinternship_data_Segments$ValueCard(title, body, icon) {
  this.iR = null;
  this.iP = null;
  this.iQ = null;
  this.iR = title;
  this.iP = body;
  this.iQ = icon;
}
export { $c_Lio_intela_sites_digitalinternship_data_Segments$ValueCard as $c_Lio_intela_sites_digitalinternship_data_Segments$ValueCard };
$p = $c_Lio_intela_sites_digitalinternship_data_Segments$ValueCard.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_digitalinternship_data_Segments$ValueCard;
/** @constructor */
function $h_Lio_intela_sites_digitalinternship_data_Segments$ValueCard() {
}
export { $h_Lio_intela_sites_digitalinternship_data_Segments$ValueCard as $h_Lio_intela_sites_digitalinternship_data_Segments$ValueCard };
$h_Lio_intela_sites_digitalinternship_data_Segments$ValueCard.prototype = $p;
$p.N = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.s = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().W(this, (-486404418), true);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lio_intela_sites_digitalinternship_data_Segments$ValueCard) && (((this.iR === x$0.iR) && (this.iP === x$0.iP)) && (this.iQ === x$0.iQ))));
});
$p.t = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().V(this);
});
$p.G = (function() {
  return 3;
});
$p.I = (function() {
  return "ValueCard";
});
$p.H = (function(n) {
  switch (n) {
    case 0: {
      return this.iR;
      break;
    }
    case 1: {
      return this.iP;
      break;
    }
    case 2: {
      return this.iQ;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$ValueCard(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bP)));
}
export { $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$ValueCard as $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$ValueCard };
var $d_Lio_intela_sites_digitalinternship_data_Segments$ValueCard = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_digitalinternship_data_Segments$ValueCard, "io.intela.sites.digitalinternship.data.Segments$ValueCard", ({
  bP: 1,
  b: 1,
  e: 1,
  a: 1
}));
export { $d_Lio_intela_sites_digitalinternship_data_Segments$ValueCard as $d_Lio_intela_sites_digitalinternship_data_Segments$ValueCard };
//# sourceMappingURL=io.intela.sites.digitalinternship.data.-Segments$-Value-Card.js.map
